import { LegalDocument, LegalLink, LegalP, LegalSection, LegalUl } from "../../components/LegalDocument"

const EFFECTIVE_DATE = "1 сентября 2025 года"

export default function PersonalData() {
    return (
        <LegalDocument title="Положение об обработке персональных данных">
            <LegalP>
                Настоящее Положение разработано в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О
                персональных данных» (далее — Закон № 152-ФЗ), с учётом изменений, вступивших в силу с{" "}
                {EFFECTIVE_DATE} (в том числе Федеральный закон от 24.06.2025 № 156-ФЗ и Федеральный закон от
                08.08.2024 № 233-ФЗ), и определяет политику Оператора в отношении обработки персональных данных при
                использовании сервиса «Мягкий кинотеатр».
            </LegalP>

            <LegalSection title="1. Общие положения">
                <LegalP>
                    1.1. Настоящее Положение об обработке персональных данных (далее — Положение) является локальным
                    актом Оператора, определяющим политику в отношении обработки персональных данных, и размещается в
                    открытом доступе в Сервисе в соответствии с ч. 2 ст. 18.1 Закона № 152-ФЗ.
                </LegalP>
                <LegalP>
                    1.2. Положение действует в отношении всех персональных данных, которые Оператор может получить от
                    субъекта персональных данных при использовании сайта{" "}
                    <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>, мобильного приложения «Мягкий
                    кинотеатр» и связанных с ними сервисов (далее — Сервис).
                </LegalP>
                <LegalP>
                    1.3. С {EFFECTIVE_DATE} согласие субъекта персональных данных на обработку его персональных данных
                    оформляется отдельно от иных документов и информации (ч. 1 ст. 9 Закона № 152-ФЗ). Текст согласия
                    приведён в разделе 12 настоящего Положения.{" "}
                    <LegalLink to="/privacy">Политика конфиденциальности</LegalLink> и{" "}
                    <LegalLink to="/terms">Пользовательское соглашение</LegalLink> не заменяют отдельное согласие на
                    обработку персональных данных.
                </LegalP>
                <LegalP>
                    1.4. Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение (обновление,
                    изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание,
                    блокирование, удаление и уничтожение персональных данных с использованием средств автоматизации и
                    без использования таких средств.
                </LegalP>
            </LegalSection>

            <LegalSection title="2. Сведения об операторе">
                <LegalP>
                    <strong className="text-white/80">Оператор персональных данных:</strong>
                    <br />
                    Общество с ограниченной ответственностью «Империя игр» (ООО «Империя игр»)
                    <br />
                    ИНН/КПП: 7452030395 / 745301001
                    <br />
                    ОГРН: 1027403888126
                    <br />
                    Юридический адрес: 454091, Челябинская область, г. Челябинск, Свердловский пр-кт, д. 51а
                    <br />
                    Сайт: <LegalLink href="https://comfortkino.ru">comfortkino.ru</LegalLink>
                    <br />
                    Telegram для обращений:{" "}
                    <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink>
                </LegalP>
            </LegalSection>

            <LegalSection title="3. Цели обработки персональных данных">
                <LegalUl
                    items={[
                        "регистрация, идентификация и авторизация Пользователя в Сервисе;",
                        "создание и сопровождение Аккаунта (Личного кабинета);",
                        "оформление, оплата и сопровождение заказов на покупку билетов;",
                        "участие Пользователя в бонусной программе лояльности;",
                        "направление сервисных уведомлений, подтверждений операций и информации о статусе заказов;",
                        "обеспечение работы технической поддержки и обработка обращений Пользователей;",
                        "соблюдение требований законодательства РФ, в том числе фискального учёта;",
                        "аналитика использования Сервиса и улучшение качества сервисов (на основании обезличенных данных).",
                    ]}
                />
            </LegalSection>

            <LegalSection title="4. Правовые основания обработки">
                <LegalP>4.1. Оператор обрабатывает персональные данные на следующих основаниях:</LegalP>
                <LegalUl
                    items={[
                        "согласие субъекта персональных данных (ст. 9 Закона № 152-ФЗ);",
                        "исполнение договора, стороной которого является субъект персональных данных (покупка билетов, использование Сервиса);",
                        "исполнение обязанностей, возложенных на Оператора законодательством РФ;",
                        "осуществление прав и законных интересов Оператора при условии, что не нарушаются права и свободы субъекта персональных данных.",
                    ]}
                />
                <LegalP>
                    4.2. С {EFFECTIVE_DATE} согласие на обработку персональных данных не может быть включено в текст
                    пользовательского соглашения, публичной оферты, анкеты или иных документов и оформляется
                    самостоятельно.
                </LegalP>
            </LegalSection>

            <LegalSection title="5. Категории субъектов и перечень персональных данных">
                <LegalP>5.1. Субъекты персональных данных: Пользователи Сервиса — физические лица.</LegalP>
                <LegalP>5.2. Обрабатываемые персональные данные:</LegalP>
                <LegalUl
                    items={[
                        "номер мобильного телефона;",
                        "фамилия, имя, отчество;",
                        "адрес электронной почты;",
                        "дата рождения;",
                        "сведения о заказах, билетах и операциях в Сервисе;",
                        "технические данные об использовании Сервиса (IP-адрес, идентификаторы устройства, cookies, данные о действиях в интерфейсе) — в объёме, необходимом для работы Сервиса.",
                    ]}
                />
                <LegalP>
                    5.3. Оператор не осуществляет обработку специальных категорий персональных данных и биометрических
                    персональных данных, за исключением случаев, прямо предусмотренных законодательством РФ.
                </LegalP>
                <LegalP>
                    5.4. Оператор не обрабатывает и не хранит реквизиты банковских карт. Оплата осуществляется через
                    сертифицированные платёжные системы.
                </LegalP>
            </LegalSection>

            <LegalSection title="6. Порядок и условия обработки">
                <LegalP>
                    6.1. Обработка персональных данных осуществляется с соблюдением принципов и правил, установленных
                    Законом № 152-ФЗ, в том числе законности, справедливости, ограничения обработки достижением
                    конкретных, заранее определённых и законных целей.
                </LegalP>
                <LegalP>
                    6.2. Оператор не принимает решений, порождающих юридические последствия для субъекта персональных
                    данных или иным образом затрагивающих его права и законные интересы, исключительно на основании
                    автоматизированной обработки персональных данных.
                </LegalP>
                <LegalP>
                    6.3. Оператор фиксирует факт, дату и способ получения согласия субъекта персональных данных, а
                    также версию текста согласия, принятую Пользователем, в целях подтверждения добровольного и
                    информированного волеизъявления.
                </LegalP>
            </LegalSection>

            <LegalSection title="7. Сроки обработки и хранения">
                <LegalP>
                    7.1. Персональные данные обрабатываются и хранятся в течение срока действия Аккаунта Пользователя,
                    а также в течение сроков, установленных законодательством РФ (в том числе для хранения фискальных
                    и бухгалтерских документов).
                </LegalP>
                <LegalP>
                    7.2. По достижении целей обработки либо при отзыве согласия персональные данные подлежат
                    уничтожению или обезличиванию, если иное не предусмотрено законом.
                </LegalP>
            </LegalSection>

            <LegalSection title="8. Передача персональных данных третьим лицам">
                <LegalP>8.1. Оператор может передавать персональные данные следующим категориям получателей:</LegalP>
                <LegalUl
                    items={[
                        "ООО «Первый ОФД» — оператор фискальных данных для формирования и направления электронных чеков (54-ФЗ);",
                        "платёжные агрегаторы и банки — для проведения оплаты (без передачи полных реквизитов карты Оператору);",
                        "государственные органы — в случаях, предусмотренных законодательством РФ.",
                    ]}
                />
                <LegalP>
                    8.2. Передача персональных данных иным третьим лицам осуществляется только с согласия субъекта
                    персональных данных, если иное не предусмотрено законом.
                </LegalP>
            </LegalSection>

            <LegalSection title="9. Обезличивание персональных данных">
                <LegalP>
                    9.1. В соответствии с изменениями Закона № 152-ФЗ, действующими с {EFFECTIVE_DATE}, Оператор
                    вправе осуществлять обезличивание персональных данных с использованием методов, предусмотренных
                    приказом Роскомнадзора от 19.06.2025 № 140 «Об утверждении требований к методам обезличивания
                    персональных данных».
                </LegalP>
                <LegalP>
                    9.2. Исходные и обезличенные массивы персональных данных хранятся раздельно. Доступ к операциям
                    обезличивания ограничен уполномоченными лицами Оператора.
                </LegalP>
                <LegalP>
                    9.3. Обезличенные данные могут использоваться для аналитики, статистики и улучшения Сервиса без
                    возможности идентификации конкретного Пользователя без дополнительной информации.
                </LegalP>
                <LegalP>
                    9.4. При получении законного требования уполномоченного органа Оператор может формировать и
                    передавать обезличенные данные в порядке, установленном законодательством РФ (ст. 13.1 Закона №
                    152-ФЗ).
                </LegalP>
            </LegalSection>

            <LegalSection title="10. Меры по защите персональных данных">
                <LegalP>
                    10.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты
                    персональных данных от неправомерного или случайного доступа, уничтожения, изменения,
                    блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий.
                </LegalP>
                <LegalP>10.2. К таким мерам относятся, в частности:</LegalP>
                <LegalUl
                    items={[
                        "ограничение доступа к персональным данным уполномоченным сотрудникам;",
                        "использование защищённых каналов передачи данных (HTTPS/TLS);",
                        "резервное копирование и контроль целостности информации;",
                        "регулярная оценка рисков и актуализация мер защиты;",
                        "обучение сотрудников правилам работы с персональными данными.",
                    ]}
                />
            </LegalSection>

            <LegalSection title="11. Права субъекта персональных данных">
                <LegalP>11.1. Субъект персональных данных имеет право:</LegalP>
                <LegalUl
                    items={[
                        "получать информацию об обработке своих персональных данных;",
                        "требовать уточнения, блокирования или уничтожения персональных данных, если они неполные, устаревшие, неточные или обрабатываются незаконно;",
                        "отозвать согласие на обработку персональных данных;",
                        "обжаловать действия или бездействие Оператора в Роскомнадзор или в суд;",
                        "на защиту своих прав и законных интересов, в том числе на возмещение убытков и компенсацию морального вреда.",
                    ]}
                />
                <LegalP>
                    11.2. Для реализации прав субъект персональных данных может направить обращение Оператору через
                    Telegram <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink>{" "}
                    или иным способом, указанным в разделе 2 настоящего Положения.
                </LegalP>
                <LegalP>
                    11.3. Оператор рассматривает обращение в сроки, установленные Законом № 152-ФЗ, и направляет
                    ответ субъекту персональных данных.
                </LegalP>
            </LegalSection>

            <LegalSection title="12. Согласие на обработку персональных данных">
                <LegalP>
                    Настоящий раздел содержит текст согласия, которое субъект персональных данных предоставляет
                    Оператору отдельно от иных документов в соответствии с ч. 1 ст. 9 Закона № 152-ФЗ (в редакции,
                    действующей с {EFFECTIVE_DATE}).
                </LegalP>
                <LegalP>
                    Я, субъект персональных данных, действуя свободно, своей волей и в своём интересе, подтверждаю,
                    что ознакомлен(а) с настоящим Положением и{" "}
                    <LegalLink to="/privacy">Политикой конфиденциальности</LegalLink>, и даю согласие ООО «Империя
                    игр» (ИНН 7452030395, ОГРН 1027403888126) на обработку моих персональных данных, а именно: номера
                    мобильного телефона, фамилии, имени, отчества, адреса электронной почты, даты рождения, сведений о
                    заказах и действиях в Сервисе, технических данных об использовании Сервиса.
                </LegalP>
                <LegalP>Цели обработки:</LegalP>
                <LegalUl
                    items={[
                        "регистрация и авторизация в Сервисе;",
                        "оформление и сопровождение заказов на билеты;",
                        "участие в бонусной программе;",
                        "направление сервисных уведомлений;",
                        "техническая поддержка;",
                        "исполнение требований законодательства РФ.",
                    ]}
                />
                <LegalP>
                    Перечень действий с персональными данными: сбор, запись, систематизация, накопление, хранение,
                    уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ),
                    обезличивание, блокирование, удаление, уничтожение — с использованием средств автоматизации и без
                    них.
                </LegalP>
                <LegalP>
                    Согласие действует с момента его предоставления до достижения целей обработки либо до его отзыва
                    субъектом персональных данных. Отзыв согласия направляется Оператору через Telegram{" "}
                    <LegalLink href="https://t.me/comfortkinohelp_bot">t.me/comfortkinohelp_bot</LegalLink>. Отзыв
                    согласия может повлечь невозможность использования отдельных функций Сервиса, требующих обработки
                    персональных данных.
                </LegalP>
            </LegalSection>

            <LegalSection title="13. Заключительные положения">
                <LegalP>
                    13.1. Настоящее Положение является общедоступным документом и размещается по адресу{" "}
                    <LegalLink to="/personal-data">/personal-data</LegalLink> в Сервисе.
                </LegalP>
                <LegalP>
                    13.2. Оператор вправе вносить изменения в Положение. Новая редакция вступает в силу с момента её
                    публикации, если иной срок не указан дополнительно.
                </LegalP>
                <LegalP>
                    13.3. Актуальная редакция Положения действует с {EFFECTIVE_DATE}. Дополнительные сведения об
                    обработке персональных данных содержатся в{" "}
                    <LegalLink to="/privacy">Политике конфиденциальности</LegalLink>.
                </LegalP>
            </LegalSection>
        </LegalDocument>
    )
}
